<template>
  <div>
    特权
  </div>
</template>
<script>
export default {};
</script>
